<template>
  <div>
    <van-nav-bar title="我的待办" left-text="返回" right-text="" @click-left="onClickLeft"/>
    <van-search
      shape="round"
      background="#2196f3"
      placeholder="请输入申请人姓名"
      clear-trigger="always"
      @search="onSearch"
      @clear="clear"
      @input="input"
      v-model="searchVal"
    />
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad">
        <van-checkbox-group v-model="result" ref="checkboxGroup">
          <van-swipe-cell v-for="item in list" :key="item.id" disabled>
            <van-card>
              <template slot="title">
                <div style="margin-left: 10px;" @click="jumpFlowDetail(item.businessUrl, item.taskId,item.processInstanceId,
                item.appNo, item.processDefinitionId, item.processDefinitionKey)">
                  <div>{{ item.processDefinitionName }}</div>
<!--                  <van-tag plain type="primary ">{{ item.taskName }}</van-tag>-->
                  <!--                  <van-tag plain type="primary ">{{ item.appNo }}</van-tag>-->
                </div>
              </template>
              <template slot="thumb">
                <van-checkbox :name="item" class="left-check" shape="square" v-if="item.taskDefinitionKey != 'apply'">
                </van-checkbox>
                <div :name="item" class="left-check" v-else></div>
              </template>
              <template slot="desc">
                <div style="margin-left: 10px;" @click="jumpFlowDetail(item.businessUrl, item.taskId,item.processInstanceId,
                item.appNo, item.processDefinitionId, item.processDefinitionKey)" v-if="item.outLine != ''">
                  {{ item.outLine }}
                </div>
                <div @click="jumpFlowDetail(item.businessUrl, item.taskId,item.processInstanceId,
                item.appNo, item.processDefinitionId, item.processDefinitionKey)" v-else style="height: 50px;">
                </div>
              </template>
              <template slot="footer">
                <div @click="jumpFlowDetail(item.businessUrl, item.taskId,item.processInstanceId,
                item.appNo, item.processDefinitionId, item.processDefinitionKey)">
                  <van-icon name="photo-o" :badge="item.variables.applyFiles.length" color="#2196f3" size="35"
                            v-if="item.variables.applyFiles != undefined && item.variables.applyFiles.length > 0"/>
                  <div>{{ item.createTime }}</div>
                </div>
              </template>
            </van-card>
            <van-divider :style="{ color: '#2196f3', borderColor: '#2196f3', padding: '0 16px', margin: '0px' }"/>
          </van-swipe-cell>
        </van-checkbox-group>
      </van-list>
      <van-empty description="暂无数据" v-if="emptyShow"/>
    </van-pull-refresh>
    <van-submit-bar decimal-length="" currency="" button-text="批量提交" @submit="onSubmit">
      <van-checkbox v-model="allChecked" @click="allSelect" shape="square">全选</van-checkbox>
      <div style="flex: 1"></div>
    </van-submit-bar>
    <van-dialog v-model="auditShow" title="批量审批" @confirm="auditSubmit" show-cancel-button width="350px">
      <van-field name="auditRadio" label="审批意见">
        <template slot="input">
          <van-radio-group v-model="auditStatus" direction="horizontal">
            <van-radio v-for="audit in auditStatusList" :name="audit.dictKey">{{ audit.dictValue }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="comment"
        rows="3"
        autosize
        label="备注"
        type="textarea"
        maxlength="50"
        placeholder="请填写备注"
        show-word-limit/>
    </van-dialog>
  </div>
</template>

<script>
import {Toast} from "vant";
import {isLogin, isWechat} from "../../utils/util";

export default {
  name: "FlowList",
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      userId: '',
      finishedText: "没有更多了",
      emptyShow: false,
      listIcon: "../../../static/images/audit.png",
      searchVal: '',
      allChecked: false,
      result: [],
      resultCount: 0,
      auditShow: false,
      auditStatus: '1',
      auditStatusList: [],
      comment: '',
      auditForm: {},
    };
  },
  mounted() {
    if(!isLogin()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.initData();
  },
  methods: {
    initData() {
      this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
        code: 'audit_status'
      }).then(res => {
        const data = res.data;
        this.auditStatusList = data;
      });
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      this.getAttenceFlowList();
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getAttenceFlowList: function () {
      this.$fetch("/attence-api/blade-flow/work/todowork-list", {
        current: 1,
        size: 500
      }).then(
        res => {
          const data = res.data;
          this.list = data.records;
          if (this.list.length > 0) {
            this.emptyShow = false;
            this.finishedText = "没有更多了";
          } else {
            this.emptyShow = true;
            this.finishedText = "";
          }
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          this.finished = true;
          console.log("返回的数据：" + JSON.stringify(this.list));
        },
        error => {
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          this.finished = true;
        }
      );
    },
    jumpFlowDetail: function (businessUrl, taskId, processInstanceId, appNo, processDefinitionId, processDefinitionKey) {
      if (processDefinitionKey.indexOf('UserLend') != -1) {
        Toast('此流程不支持在微考勤处理！');
        return;
      }
      let path = "/attenceflow/" + businessUrl;
      this.$router.push({
        path: path,
        query: {
          taskId: taskId,
          processInstanceId: processInstanceId,
          appNo: appNo,
          processDefinitionId: processDefinitionId,
          pageType: 0,
        }
      });
    },
    onSearch(val) {
      console.log("输入的值：" + val);
      if (val) {
        this.list = this.list.filter(item => {
          if (item.hasOwnProperty('outLine')) {
            if (item.outLine.includes(val)) {
              return item
            }
          }
        });
      } else {
        this.onRefresh();
      }
    },
    clear() {
      this.onRefresh();
    },
    input(val) {
      if (!val) {
        this.onRefresh();
      }
    },
    onClickLeft: function () {
      this.$router.push({
        path: "/attenceflow/AttenceHome",
        query: {}
      });
    },
    allSelect() {
      if (this.allChecked) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll();
      }
    },
    onSubmit() {
      if (this.result.length == 0) {
        Toast('请选择至少一条数据');
        return;
      }
      this.auditShow = true;
    },
    auditSubmit() {
      if (this.auditStatus != '1' && this.comment == '') {
        Toast('请先填写备注');
        return;
      }
      this.auditForm.auditStatus = this.auditStatus;
      this.auditForm.comment = this.comment;
      this.auditForm.flow = this.result;

      this.$bodyPost("/attence-api/blade-flow/work/oneKeyAuditTask", this.auditForm).then(res => {
        const data = res.data;
        Toast('批量审批成功');
        this.auditShow = false;
        this.auditForm = {};
        this.auditStatus = '1';
        this.comment = '';
        this.onRefresh();
      });
    }
  },
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

.left-check {
  position: absolute;
  top: 0;
  height: 100%;
}

/deep/ .van-card__thumb {
  position: relative;
  -webkit-box-flex: 0;
  -webkit-flex: none;
  flex: none;
  width: 30px;
  margin-right: 8px;
}

</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/FlowList.vue